import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import './inv-jobs.css';

// ── Jobb-lista (filter + sortering) ──────────────────────────

(function () {
	const wrap = document.querySelector('.inv-jobs-wrap');
	if (!wrap) return;

	const list  = wrap.querySelector('.inv-jobs-list');
	const cards = Array.from(list.querySelectorAll('.inv-job-card'));

	let activeFilters = { region: '', type: '' };
	let activeOrder   = 'desc';

	// ── URL ──────────────────────────────────────────────────

	function readURL() {
		const p = new URLSearchParams(window.location.search);
		activeFilters.region = p.get('region') || '';
		activeFilters.type   = p.get('type')   || '';
		activeOrder          = p.get('order')  || 'desc';
	}

	function writeURL() {
		const p = new URLSearchParams();
		if (activeFilters.region)   p.set('region', activeFilters.region);
		if (activeFilters.type)     p.set('type',   activeFilters.type);
		if (activeOrder !== 'desc') p.set('order',  activeOrder);
		const qs = p.toString();
		history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
	}

	// ── Filter + sort ─────────────────────────────────────────

	function apply() {
		cards.forEach(card => {
			const regionOk = !activeFilters.region || card.dataset.region === activeFilters.region;
			const typeOk   = !activeFilters.type   || card.dataset.type   === activeFilters.type;
			card.style.display = (regionOk && typeOk) ? '' : 'none';
		});

		const visible = cards.filter(c => c.style.display !== 'none');
		visible
			.sort((a, b) => {
				const diff = new Date(a.dataset.date) - new Date(b.dataset.date);
				return activeOrder === 'asc' ? diff : -diff;
			})
			.forEach(card => list.appendChild(card));

		syncLabels();
		syncClear();
	}

	// ── Labels ────────────────────────────────────────────────

	function syncLabels() {
		wrap.querySelectorAll('.inv-filter-trigger').forEach(btn => {
			const f   = btn.dataset.filter;
			const def = btn.dataset.default;

			if (f === 'order') {
				btn.textContent = activeOrder === 'asc' ? 'Datum stigande' : 'Datum fallande';
			} else if (activeFilters[f]) {
				btn.textContent = activeFilters[f];
				btn.classList.add('is-active');
			} else {
				btn.textContent = def;
				btn.classList.remove('is-active');
			}
		});
	}

	function syncClear() {
		const btn = wrap.querySelector('.inv-clear-filters');
		if (btn) btn.hidden = !(activeFilters.region || activeFilters.type);
	}

	// ── Dropdowns ─────────────────────────────────────────────

	function closeAll() {
		wrap.querySelectorAll('.inv-dropdown').forEach(d => d.classList.remove('is-open'));
	}

	wrap.querySelectorAll('.inv-filter-trigger').forEach(btn => {
		btn.addEventListener('click', e => {
			e.preventDefault();
			e.stopPropagation();
			const dd      = wrap.querySelector(`.inv-dropdown[data-for="${btn.dataset.filter}"]`);
			const wasOpen = dd.classList.contains('is-open');
			closeAll();
			if (!wasOpen) dd.classList.add('is-open');
		});
	});

	wrap.querySelectorAll('.inv-dropdown a').forEach(opt => {
		opt.addEventListener('click', e => {
			e.preventDefault();
			const f = opt.closest('.inv-dropdown').dataset.for;
			if (f === 'order') {
				activeOrder = opt.dataset.value;
			} else {
				activeFilters[f] = opt.dataset.value;
			}
			closeAll();
			writeURL();
			apply();
		});
	});

	const clearBtn = wrap.querySelector('.inv-clear-filters');
	if (clearBtn) {
		clearBtn.addEventListener('click', e => {
			e.preventDefault();
			activeFilters = { region: '', type: '' };
			writeURL();
			apply();
		});
	}

	document.addEventListener('click', e => {
		if (!e.target.closest('.inv-jobs-toolbar')) closeAll();
	});

	readURL();
	apply();
})();

// ── Jobb-slider ───────────────────────────────────────────────

document.querySelectorAll('.inv-jobs-slider').forEach(el => {
	const count = el.querySelectorAll('.splide__slide').length;
	new Splide(el, {
		type:        count > 4 ? 'loop' : 'slide',
		perPage:     4,
		perMove:     1,
		gap:         '2rem',
		arrows:      true,
		pagination:  false,
		breakpoints: {
			1024: { perPage: 3 },
			740:  { perPage: 2 },
			480:  { perPage: 1 },
		},
	}).mount();
});
